<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="ma-0"
    >
      <field-view-card
        ref="field-view-card"
        v-if="isViewMode"
        :mode.sync="mode"
      >
      </field-view-card>
      <field-edit-card
        ref="field-edit-card"
        v-else
        :mode.sync="mode"
      >
      </field-edit-card>
    </v-row>
  </v-container>
</template>

<script>
  import {FEATURE_CARD_STATE} from "../../../../helpers/geometries/constants"
  import FieldViewCard from "./FieldViewCard"
  import FieldEditCard from "./FieldEditCard"
  import {isEqual} from "lodash/lang"
  import {Field} from "../../../../helpers/fields/models"

  const _FieldMap = Symbol.for("_FieldMap")
  const _FieldLayer = Symbol.for("_FieldLayer")
  const _FieldFeature = Symbol.for("_FieldFeature")

  export default {
    name: "FieldCardWrapper",
    components: {FieldEditCard, FieldViewCard},
    props: {
      map: {
        type: Object,
        required: true,
      },
      feature: {
        type: Field,
        required: true
      },
      layer: {
        type: window.L.Polygon,
        required: true
      }
    },
    data: () => ({
      mode: FEATURE_CARD_STATE.VIEW,
    }),
    provide() {
      return {
        [_FieldFeature]: () => this.feature,
        [_FieldLayer]: () => this.layer,
        [_FieldMap]: () => this.map
      }
    },
    computed: {
      isViewMode() {
        return isEqual(this.mode, FEATURE_CARD_STATE.VIEW)
      },
    },
  }
</script>

<style scoped>
</style>
